import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskChangeDeadline = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskChangeDeadline;
